import { SAVE_SELECTED_MEMBER_ROLE_STATUS } from 'stores/redux/actions/types';
import reducer from '../common/reducer';

const addReducer = reducer(SAVE_SELECTED_MEMBER_ROLE_STATUS);
export default addReducer;
